/**
 * @author [Sam]
 * @desc [This interceptor Provides Caching Data for get request's which
 *  stops multiple Get calls, which uses a Cache service.
 *  the request sent with require a header cache:true to cache the requests]
 */
import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpInterceptor, HttpHandler } from '@angular/common/http';

import { tap } from 'rxjs/operators';

import { NGXLogger } from 'ngx-logger';
import { Observable, of } from 'rxjs';
import {CacheService} from "../../Services/cache.service";

@Injectable()
export class CachingInterceptor implements HttpInterceptor {
  constructor(private cache: CacheService, private logger: NGXLogger) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.headers.get('cache')) {
      this.logger.debug('cached');
      req = req.clone({ headers: req.headers.delete('cache') });
      const cachedResponse = this.cache.get(req);
      return cachedResponse ? of(cachedResponse) : this.sendRequest(req, next, this.cache);
    } else {
      return next.handle(req).pipe(tap(event => this.handleSkip(event)));
    }
  }

  private handleSkip(evt: HttpEvent<any>) {
    if (evt instanceof HttpResponse) {
      this.logger.debug('skipped caching');
    }
  }

  sendRequest(req: HttpRequest<any>, next: HttpHandler, cache: CacheService): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          cache.put(req, event);
        }
      })
    );
  }
}
